<mode-toast type="success" [hideIcon]="true" [canTapToDismiss]="false">
  <div class="feedback-toast-content">
    <capra-icon class="success-icon" icon="icon-check"></capra-icon>
    <div class="toast-body">
      <h4 class="title">Marked helpful.</h4>
      <p class="success-message">Thanks for improving AI Assist!</p>
    </div>
  </div>
</mode-toast>
